import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // 1. ZMIANA: Twarde wyłączenie automatycznego scrollowania przez Safari/Chrome na iOS
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const scrollToTop = () => {
      window.scrollTo(0, 0); // Zwykłe window.scrollTo bez obiektu działa najstabilniej na iOS
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    };

    // 2. ZMIANA: Podwójny requestAnimationFrame zamiast setTimeout
    // Pierwszy czeka na przeliczenie DOM przez Reacta, drugi czeka na fizyczne narysowanie ekranu.
    // To upewnia się, że iPhone nie zignoruje naszej prośby o powrót na górę.
    const req1 = requestAnimationFrame(() => {
      requestAnimationFrame(scrollToTop);
    });

    // Sprzątanie pamięci w przypadku szybkiego przeklikiwania
    return () => cancelAnimationFrame(req1);
  }, [pathname, search]);

  return null;
}

export default ScrollToTop;
